import { StoreWorkshopStats } from '@euler/model/StoreWorkshopStats';
import { TaskListItem } from '@euler/model/TaskListItem';
import { useServiceFactory } from '@euler/services/factory';
import { fetchUnfinishedTasks } from './fetchUnfinishedTasks';
import { todayRange } from './todayRange';
import { Refreshing, useRefreshing } from './useRefreshing';

export type WorkshopTasks = {
  tasks: TaskListItem[];
  stats: StoreWorkshopStats;
};

/** The open tasks and today's counts. */
export function useWorkshopBoard(): Refreshing<WorkshopTasks> {
  const { taskService } = useServiceFactory();
  return useRefreshing(
    'tasks',
    async () => {
      const { start, end } = todayRange(new Date());
      const [tasks, stats] = await Promise.all([
        fetchUnfinishedTasks(taskService),
        taskService.getWorkshopStats(start, end),
      ]);
      return { tasks, stats };
    },
    [taskService],
  );
}
